module.exports = __webpack_public_path__ + "static/img/pggpopulation.f2c0f7c8.png";